export default {"src":"/_next/static/image/public/images/svgs/arrow-curved-down-right.7daa5f9822b65688092228bea95e8680.svg","height":77,"width":23};